module.exports = __webpack_public_path__ + "img/closed_barrier.331ebdb5.svg";